import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TabView, TabPanel } from 'primereact/tabview';
import OrderSerialNumbersTable from './components/OrderSerialNumbersTable';
import DeliveryNoteTable from './components/DeliveryNoteTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import { usePermissions } from '../../../hooks/usePermissions';
import { selectUserParams } from '../../../store/slices/userParamsSlice';

const OrderPickupPage = () => {
  const { th } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);
  const userParams = useSelector(selectUserParams);
  const { hasDealerRole, hasSalesDealerRole, hasServiceDealerRole, hasPartTeamRole, hasWarrantyTeamRole, hasAdminRole, hasWarrantyManagerRole } = usePermissions();

  const isDealerUser = hasDealerRole() || hasSalesDealerRole() || hasServiceDealerRole();
  const isInternalUser = hasPartTeamRole() || hasWarrantyTeamRole() || hasAdminRole() || hasWarrantyManagerRole();
  const isForeignDealer = userParams?.isDomestic === false && isDealerUser && !isInternalUser;

  return (
    <div className="card">
      <div className="flex justify-content-between align-items-center mb-3">
        <h2 className="m-0">{th('menu.orderPickup')}</h2>
      </div>

      <TabView activeIndex={isForeignDealer ? 0 : activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header={th('table.invoice')}>
          <OrderSerialNumbersTable />
        </TabPanel>
        {!isForeignDealer && (
          <TabPanel header={th('table.deliveryNote')}>
            <DeliveryNoteTable />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
};

export default OrderPickupPage;
